import { render, staticRenderFns } from "./text-subpage.vue?vue&type=template&id=2ed1d064&scoped=true&"
import script from "./text-subpage.vue?vue&type=script&lang=js&"
export * from "./text-subpage.vue?vue&type=script&lang=js&"
import style0 from "./text-subpage.vue?vue&type=style&index=0&id=2ed1d064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed1d064",
  null
  
)

export default component.exports